import { Dispatch, SetStateAction } from "react";
import { IFilters } from "../Filters/Filters.def";
export interface IAiSummaryDrawerProps {
  closeAiSummaryDrawer: () => void;
  onSendMessage: (filters: IFilters) => void;
  basedOnSelectedFiltersGetSummary?: (filters?: IFilters) => void;
  setFilters: Dispatch<SetStateAction<IFilters>>;
  filters: IFilters;
  loading: boolean;
  data: IData;
  error: string;
}

export const HOME_STORIES = {
  "1": "Single-Story Homes",
  "1.5": "One and a Half-Story Homes",
  "2": "Two-Story Homes",
  "3": "Three-Story Homes",
  "4": "Four-Story Homes",
} as const;

export const SCHOOL_KEYS = [
  "high_school",
  "middle_school",
  "elemantary_school",
  "school_district",
] as const;

/** Pairs of amenity values that can’t coexist */
export const AMENITY_MUTEX: Record<string, string> = {
  pool: "no_pool",
  no_pool: "pool",
};

export type SchoolKey = (typeof SCHOOL_KEYS)[number];

export interface SchoolIdMap {
  high_school?: string;
  middle_school?: string;
  elemantary_school?: string;
  school_district?: string;
}

export const keyDisplay: Record<string, string> = {
  high_school: "high school",
  middle_school: "middle school",
  elemantary_school: "elementary school",
  school_district: "school district",
};

interface IData {
  total: number;
  // aggregates: IAggregates;
  aggregates: any;
  summary: ISummary;
  valid: boolean;
  headings: IHeadings;
  excution_time: number;
  data_source: string;
}

interface IHeadings {
  ammenities: IHeading;
  attrib: IHeading;
  schools: IHeading;
  neighborhoods: IHeading;
}

interface IHeading {
  title: string;
  subtitle?: string;
  key: string;
}

interface ISummary {
  intro: string;
}

interface IAggregates {
  ammenities: Amenities;
  attrib: Attrib;
  neighborhoods: Neighborhoods;
  schools: Schools;
  schooldist: Schooldist;
}

interface Schooldist {
  "101902": _101902;
  "101903": _101902;
  "101907": _101902;
  "101912": _101902;
  "101919": _101902;
  "101920": _101902;
}

interface _101902 {
  val: string;
  doc_count: string;
  meta: Meta2;
}

interface Meta2 {
  Name: string;
  ACCT_Rating: null;
  District_CD: string;
  stars: string;
  stars_text: string;
}

interface Schools {
  "2": _2;
  "101912008": _101912008;
  "101912009": _101912008;
  "101912012": _101912008;
  "101912020": _101912008;
  "101912044": _101912008;
  "101912053": _101912008;
  "101912058": _101912008;
  "101912064": _101912008;
  "101912068": _101912008;
  "101912116": _101912008;
  "101912204": _101912008;
  "101912257": _101912008;
  "101914111": _101912008;
}

interface _101912008 {
  val: string;
  schooltype: string;
  doc_count: string;
  meta: Meta;
}

interface Meta {
  Name: string;
  ACCT_Rating: string;
  Campus_CD: string;
  stars: string;
  stars_text: string;
}

interface _2 {
  val: string;
  schooltype: string;
  doc_count: string;
}

interface Neighborhoods {
  toppricetrends: Toppricetrends;
}

interface Toppricetrends {
  values: Values4;
  param: string;
}

interface Values4 {
  "10829||hearthwood condo": _10829hearthwoodCondo;
  "11548||oakwood gardens condo": _10829hearthwoodCondo;
  "259||montrose": _10829hearthwoodCondo;
  "10599||pine village north t/h": _10829hearthwoodCondo;
  "12210||great uptown": _10829hearthwoodCondo;
  "1588||kashmere gardens": _10829hearthwoodCondo;
  "3446||highland acre homes": _10829hearthwoodCondo;
  "1696||fidelity": _10829hearthwoodCondo;
  "1756||sunnyside gardens": _10829hearthwoodCondo;
  "10761||baywind condo": _10829hearthwoodCondo;
}

interface _10829hearthwoodCondo {
  val: string;
  term: string;
  doc_count: string;
}

interface Attrib {
  stories: Stories;
  forcl: Forcl;
  new_constr2: Newconstr2;
}

interface Newconstr2 {
  values: Values3;
  valid: boolean;
  simple: boolean;
  title: string;
  selected: boolean;
}

interface Values3 {
  Yes: Yes;
}

interface Yes {
  val: string;
  doc_count: number;
}

interface Forcl {
  values: Values2;
  simple: boolean;
  valid: boolean;
  title: string;
  selected: boolean;
}

interface Values2 {
  "1": Value;
}

interface Stories {
  values: Values;
  simple: boolean;
  valid: boolean;
  selected: boolean;
  title: string;
}

interface Values {
  "1": Value;
  "2": Value;
  "3": Value;
  "4": Value;
  "1.5": Value;
}

interface Amenities {
  wheelchair: Wheelchair;
  private_pool: Wheelchair;
  area_pool: Wheelchair;
  culdesac: Wheelchair;
  waterview: Wheelchair;
  ingolfcom: Wheelchair;
  waterfront: Wheelchair;
}

interface Wheelchair {
  values: Value[];
  valid: boolean;
  title: string;
  selected: boolean;
}

interface Value {
  val: number;
  doc_count: string;
}
